import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoCategorySelector.css';

const VideoCategorySelector = ({
  categories = {},
  selectedCategory,
  selectedFormat,
  onCategoryChange,
  onFormatChange,
  disabled = false,
}) => {
  const { t } = useTranslation(['discovery']);

  // Правильная структура данных
  let contentCategories = {};
  let videoFormats = {};

  // Ищем в правильном месте - categories.categories
  if (categories?.categories?.content_categories) {
    contentCategories = categories.categories.content_categories;
  } else if (categories?.content_categories) {
    // Fallback для старой структуры
    contentCategories = categories.content_categories;
  } else if (categories?.categories && typeof categories.categories === 'object') {
    // Fallback если categories - это сами категории
    contentCategories = categories.categories;
  }

  // Ищем форматы в правильном месте - categories.categories
  if (categories?.categories?.video_formats) {
    videoFormats = categories.categories.video_formats;
  } else if (categories?.video_formats) {
    // Fallback для старой структуры
    videoFormats = categories.video_formats;
  }

  // Обработчик изменения категории
  const handleCategoryChange = (event) => {
    const category = event.target.value;
    
    if (category === '' || category === null || category === undefined) {
      onCategoryChange('');
    } else {
      onCategoryChange(category);
    }
  };

  // Обработчик изменения формата
  const handleFormatChange = (event) => {
    const format = event.target.value;
    
    if (format === '' || format === null || format === undefined) {
      onFormatChange('');
    } else {
      onFormatChange(format);
    }
  };

  // Проверяем наличие категорий и форматов
  const hasCategories = contentCategories && Object.keys(contentCategories).length > 0;
  const hasVideoFormats = videoFormats && Object.keys(videoFormats).length > 0;

  return (
    <div className="video-category-selector">
      {/* Выбор категории содержимого */}
      <div className="video-category-selector__group">
        <select
          id="content-category"
          className="video-category-selector__select"
          value={selectedCategory || ''}
          onChange={handleCategoryChange}
          disabled={disabled}
        >
          {/* Опция "Все категории" */}
          <option value="">
            {t('videoDiscovery.categorySelector.allCategories', 'Все категории')}
          </option>
          
          {/* Рендерим категории */}
          {hasCategories && Object.entries(contentCategories).map(([catKey, catData]) => {
            // Определяем базовое название для отображения
            let displayTitle = catKey;
            
            if (catData && typeof catData === 'object') {
              if (catData.title) {
                displayTitle = catData.title;
              }
            } else if (typeof catData === 'string') {
              displayTitle = catData;
            }
            
            // Пробуем найти перевод категории
            const translatedTitle = t(`categories.${catKey}`, displayTitle);
            displayTitle = translatedTitle;
            
            return (
              <option key={catKey} value={catKey}>
                {displayTitle}
              </option>
            );
          })}

          {/* Fallback опции если нет данных */}
          {!hasCategories && (
            <option disabled>Загрузка категорий...</option>
          )}
        </select>
      </div>

      {/* Выбор формата видео - ВСЕГДА показываем */}
      <div className="video-category-selector__group">
        <select
          id="video-format"
          className="video-category-selector__select"
          value={selectedFormat || ''}
          onChange={handleFormatChange}
          disabled={disabled}
        >
          <option value="">
            {t('videoDiscovery.categorySelector.allFormats', 'Все форматы')}
          </option>
          
          {hasVideoFormats && Object.entries(videoFormats).map(([format, description]) => {
            // Для новых форматов используем описание как основное название
            let displayName = format;
            
            if (Array.isArray(description) && description.length > 0) {
              displayName = description[0]; // Берем первое описание как основное название
            }
            
            // Пытаемся найти перевод, fallback - наше определенное имя
            const translatedName = t(`videoDiscovery.formats.${format}`, displayName);
            
            return (
              <option key={format} value={format}>
                {translatedName}
              </option>
            );
          })}

          {/* Fallback опции если нет данных */}
          {!hasVideoFormats && (
            <option disabled>Загрузка форматов...</option>
          )}
        </select>
      </div>
    </div>
  );
};

export default VideoCategorySelector;